import React, { useEffect } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { analytics, errorAnalytics } from '../helper/helper';

const ErrorFallback = ({ error, componentStack, resetError }) => {
  useEffect(() => {
    analytics.page("Error", {
      error: error.message,
      componentStack: componentStack,
      errorComplete: JSON.stringify(error),
    });
    errorAnalytics("Unknown Error", componentStack);
  }, [error]);
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: 3,
        textAlign: 'center',
        backgroundColor: '#f8f9fa'
      }}
    >
      <Typography variant="h4" color="error" gutterBottom>
        Oops! Something went wrong
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={resetError}
        sx={{ mb: 2 }}
      >
        Try Again
      </Button>
    </Box>
  );
};

export default ErrorFallback; 